import Colors from '../../Colors';
import light from '../Light/Colors';

const colors = {
  ...light,
  primaryColor: Colors.vfRed,
  primaryColorRGBA: Colors.vfRedRGBA,
  secondryColor: Colors.white,
  tintColor: Colors.dark_grey,
  tintColorRGBA: Colors.whiteRGBA,
  accentColor: Colors.white,
  activeColorTwo: Colors.white,
  activeColorThree: Colors.lightOcean,
  activeColorFour: Colors.white,
  accentColorRGBA: Colors.blackRGBA,
  activeTabColor: Colors.tangerine,
  activeTabColorThree: Colors.coral,
  activeColor: Colors.ocean,
  activeColorRGBA: Colors.oceanRGBA,
  inActiveColor: Colors.whiteSmoke,
  inActiveColorTwo: Colors.dark_grey,
  inActiveColorThree: Colors.white,
  inActiveColorFour: Colors.white,
  radioButtonBorderColor: Colors.white,
  headerColor: Colors.white,
  textColor: Colors.white,
  textColorTwo: Colors.veryLightPink,
  textColorThree: Colors.white,
  textColorFive: Colors.white,
  textColorSix: Colors.veryLightPink,
  textColorSeven: Colors.white,
  textColorEight: Colors.white,
  textColorNine: Colors.white,
  textColorTen: Colors.coral,
  optionBorderColor: Colors.brownGrey,
  borderColor: Colors.dark_grey,
  borderColorTwo: Colors.veryLightPink,
  borderColorThree: Colors.charcoalGrey,
  borderColorThreeRGBA: Colors.veryLightPinkTwoRGBA,
  borderColorFour: Colors.dark_grey,
  borderColorFive: Colors.white,
  borderColorSix: Colors.light_grey,
  borderColorSeven: Colors.veryLightPink,
  borderColorEight: Colors.light_grey,
  borderColorNine: Colors.dark_grey,
  horizontalLineColor: Colors.charcoalGrey,
  errorColor: Colors.error,
  overlayColor: Colors.overlay,
  backgroundColor: Colors.blackFour,
  fillColor: Colors.smoothGrey,
  fillColorTwo: Colors.white,
  loadingTextColor: Colors.white,
  backgroundColorTwo: Colors.blackThree,
  backgroundColorThree: Colors.blackFour,
  backgroundColorFour: Colors.charcoalGrey,
  backgroundColorFive: Colors.blackThree,
  backgroundColorSix: Colors.blackTwo,
  backgroundColorSeven: Colors.blackThree,
  cardBackgroundColor: Colors.dark_grey,
  cardBackgroundColorTwo: Colors.smoothGrey,
  transparentColor: Colors.transparent,
  windowTintColor: Colors.windowTint,
  shadowColor: Colors.linegrey,
  shadowColorTwo: Colors.darkShadow,
  inactiveTrayItemColor: Colors.platinum,
  trayHandleButton: Colors.brownGreyTwo,
  toggleColor: Colors.whiteSmoke,
  headerTitleColor: Colors.white,
  showMoreColor: Colors.tangerine,
  cardHeaderTitleColor: Colors.veryLightPink,
  sectionHeaderTextColor: Colors.white,
  sectionItemTextColor: Colors.veryLightPink,
  toggleBackgroundColor: Colors.transparent,
  lightTextColor: Colors.veryLightPink,
  nonCompletedCircle: Colors.mono3,
  errorCardColor: Colors.blackFour,
  tryAgainColor: Colors.tangerine,
  shimmerBorder: Colors.very_dark_grey,
  shimmerEdgesColor: Colors.very_dark_grey,
  shimmerCenterColor: Colors.smoothGrey,
  statusBarColor: Colors.blackFour,
  toggleBorderColor: Colors.white,
  hyperlink: Colors.tangerine,
  hyperlinkTwo: Colors.tangerine,
  hyperlinkThree: Colors.white,
  hyperlinkFour: Colors.tangerine,
  hyperlinkFive: Colors.tangerine,
  radioButton: Colors.blue_three,
  tutorialBackgroundColor: Colors.blackFour,
  divider: Colors.light_grey,
  dividerTwo: Colors.dark_grey,
  dividerThree: Colors.dark_grey,
  subtitle: Colors.veryLightPink,
  usagePercentage: Colors.veryLightPink,
  activeTabColorTwo: Colors.white,
  indicatorBackground: Colors.charcoalGrey,
  inActiveDot: Colors.light_grey,
  errorMessageColor: Colors.white,
  subErrorMessageColor: Colors.veryLightPink,
  rememberMeText: Colors.cardBackground,
  inputIconColor: Colors.white,
  quickActionBackground: Colors.dark_grey,
  textColorFour: Colors.light_green,
  boldTextColor: Colors.white,
  cardBackgroundColorThree: Colors.thinDark,
  cardBackgroundColorFour: Colors.blackTwo,
  seeBillColor: Colors.fresh_orangeTwo,
  filterBarItemColor: Colors.smoothGrey,
  percentageIndicator: Colors.ocean,
  usageTitle: Colors.mono5,
  usageSubTitle: Colors.secondary7_inverse,
  activeStep: Colors.primaryRed,
  inactiveSeparator: Colors.mono3,
  quickActionGradientColors: {
    primary: [Colors.vfRed, Colors.vfRed, Colors.activeRed],
    secondary: [Colors.dark_grey, Colors.dark_grey],
  },
  picker: {
    top: Colors.mine,
    bottom: Colors.dark_grey,
    activeItem: Colors.dove,
    dropdownActiveItem: Colors.vfGrey,
    chevronInActive: Colors.veryLightGreyThree,
    chevronActive: Colors.white,
    doneText: Colors.white,
    placeholder: Colors.veryLightPink,
    itemColor: Colors.white,
  },
  VFDivider: {
    primary: Colors.thinDark,
    secondary: Colors.whiteRGBA(0.32),
    tertiary: Colors.smoothGrey,
  },
  buttons: {
    primary: {
      default: Colors.vfRed,
      active: Colors.activeRed,
      borderColor: Colors.primaryRed,
    },
    primaryWhite: {
      default: Colors.white,
      active: Colors.activeGrey,
    },
    secondary: {
      default: Colors.transparent,
      active: Colors.charcoalGrey,
      borderColor: Colors.white,
    },
    tertiary: {
      default: Colors.platinum,
      active: Colors.veryLightPink,
    },
    quaternary: {
      default: Colors.transparent,
      active: Colors.charcoalGrey,
      borderColor: Colors.white,
    },
    quinary: {
      default: Colors.transparent,
      active: Colors.transparent,
      borderColor: Colors.white,
    },
    tray: {
      default: Colors.vfRed,
      active: Colors.blackTwo,
    },
    option: {
      default: Colors.background,
      active: Colors.offWhite,
    },
    default: {
      default: Colors.smoothGrey,
      active: Colors.blackTwo,
    },
    disabled: Colors.smoothGrey,
    disabledTwo: Colors.light_grey,
    disabledThree: Colors.smoothGrey,
  },
  textButtons: {
    primary: {
      default: Colors.white,
    },
    primaryWhite: {
      default: Colors.blackTwo,
    },
    secondary: {
      default: Colors.white,
    },
    tertiary: {
      default: Colors.blackTwo,
    },
    quaternary: {
      default: Colors.white,
    },
    quinary: {
      default: Colors.white,
    },
    disabled: Colors.blackTwo,
  },
  textInput: {
    default: {
      baseColor: Colors.very_light_grey,
      tintColor: Colors.blue_three,
      selectionColor: Colors.warm_grey_two,
      baseColorTwo: Colors.white,
      labelTextColor: Colors.veryLightPink,
      helperTextColor: Colors.veryLightPink,
    },
    error: {
      baseColor: Colors.tangerine,
      tintColor: Colors.tangerine,
      helperText: Colors.tangerine,
      selectionColor: Colors.warm_grey_two,
    },
  },
  text: {
    primary: Colors.white,
    primaryWhite: Colors.white,
    secondary: Colors.white,
    tertiary: Colors.tangerine,
    textWithIcon: Colors.white,
    text: Colors.white,
    primaryGrey: Colors.very_light_grey,
  },
  checkBox: {
    background: Colors.lightOcean,
    mark: Colors.blackTwo,
  },
  backgroundGradientColors: [Colors.vfRed, Colors.darkRedTwo],
  background: {
    primary: [Colors.dark_grey_2, Colors.blackThree],
    //temp value until design team updates the design
    //should represent colors to be viewed instead of dark red wave
    secondary: [Colors.vfRed, Colors.darkRedTwo],
    tertiary: [Colors.dark_grey_2, Colors.blackThree],
  },
  badge: {
    positive: Colors.success,
    neutral: Colors.tangerine,
    critical: Colors.vfRed,
    processing: Colors.warm_grey_two,
  },
  linearGradient: {
    //same like primary but separated into 2 parts
    primary1: [Colors.dark_grey_2, Colors.dark_grey_2],
    primary2: [Colors.dark_grey_2, Colors.blackThree],
  },
  countDown: {
    seperator: Colors.white,
    digit: Colors.white,
    bracket: Colors.white,
  },
};


const DarkColors = { ...colors }

export {
  DarkColors
}

export default colors;
